(self["webpackChunkheyholy_ss_theme"] = self["webpackChunkheyholy_ss_theme"] || []).push([["/assets/digital-promo-product"],{

/***/ "./src/assets/js/digital-promo-product.js":
/*!************************************************!*\
  !*** ./src/assets/js/digital-promo-product.js ***!
  \************************************************/
/***/ (() => {

function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DigitalPromoManager = /*#__PURE__*/function () {
  function DigitalPromoManager() {
    var _window$theme;
    _classCallCheck(this, DigitalPromoManager);
    if (!((_window$theme = window.theme) !== null && _window$theme !== void 0 && _window$theme.digitalPromo)) return;
    this.config = window.theme.digitalPromo;
    if (!this.config.isRegionAllowed) return;
    this.isProcessing = false;
    this._isRedispatch = false;
    this.bindEvents();
    this.checkAndSync();
  }
  return _createClass(DigitalPromoManager, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;
      document.addEventListener('ajaxProduct:added', function (e) {
        if (_this._isRedispatch) return;
        e.stopImmediatePropagation();
        _this.syncThenRedispatch(e);
      }, true // capture phase — runs before CartForm.buildCart() and CartDrawer
      );
    }
  }, {
    key: "syncThenRedispatch",
    value: function () {
      var _syncThenRedispatch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(originalEvent) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.checkAndSync();
            case 1:
              this._isRedispatch = true;
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: originalEvent.detail
              }));
              this._isRedispatch = false;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function syncThenRedispatch(_x) {
        return _syncThenRedispatch.apply(this, arguments);
      }
      return syncThenRedispatch;
    }()
  }, {
    key: "checkAndSync",
    value: function () {
      var _checkAndSync = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this2 = this;
        var response, cart, shouldHave, digitalItem, hasIt, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!this.isProcessing) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              this.isProcessing = true;
              _context2.p = 2;
              _context2.n = 3;
              return fetch("/cart.js?t=".concat(Date.now()));
            case 3:
              response = _context2.v;
              _context2.n = 4;
              return response.json();
            case 4:
              cart = _context2.v;
              window.cartData = cart;
              shouldHave = cart.items.some(function (item) {
                return item.product_type === 'Trockenfutter' || item.product_type === 'Nassfutter';
              });
              digitalItem = cart.items.find(function (item) {
                return item.variant_id === _this2.config.variantId;
              });
              hasIt = Boolean(digitalItem);
              if (!(shouldHave && !hasIt)) {
                _context2.n = 6;
                break;
              }
              _context2.n = 5;
              return this.addDigitalProduct();
            case 5:
              _context2.n = 8;
              break;
            case 6:
              if (!(!shouldHave && hasIt)) {
                _context2.n = 8;
                break;
              }
              _context2.n = 7;
              return this.removeDigitalProduct(digitalItem.key);
            case 7:
              cart.items = cart.items.filter(function (item) {
                return item.variant_id !== _this2.config.variantId;
              });
              cart.item_count -= digitalItem.quantity;
              window.cartData = cart;
            case 8:
              _context2.n = 10;
              break;
            case 9:
              _context2.p = 9;
              _t = _context2.v;
              console.error('DigitalPromo: sync error', _t);
            case 10:
              _context2.p = 10;
              this.isProcessing = false;
              return _context2.f(10);
            case 11:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 9, 10, 11]]);
      }));
      function checkAndSync() {
        return _checkAndSync.apply(this, arguments);
      }
      return checkAndSync;
    }()
  }, {
    key: "addDigitalProduct",
    value: function addDigitalProduct() {
      if (document.querySelector('quiz-container')) {
        return Promise.resolve();
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: this.config.variantId,
          quantity: 1,
          properties: {
            __free_product: 'true'
          }
        })
      }).then(function (r) {
        return r.json();
      })["catch"](function (err) {
        return console.error('DigitalPromo: add error', err);
      });
    }
  }, {
    key: "removeDigitalProduct",
    value: function removeDigitalProduct(itemKey) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0
        })
      }).then(function (r) {
        return r.json();
      })["catch"](function (err) {
        return console.error('DigitalPromo: remove error', err);
      });
    }
  }]);
}();
var DigitalPromoProduct = /*#__PURE__*/function (_HTMLElement) {
  function DigitalPromoProduct() {
    _classCallCheck(this, DigitalPromoProduct);
    return _callSuper(this, DigitalPromoProduct, arguments);
  }
  _inherits(DigitalPromoProduct, _HTMLElement);
  return _createClass(DigitalPromoProduct, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      // UI-only component
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('digital-promo-product')) {
  customElements.define('digital-promo-product', DigitalPromoProduct);
}
document.addEventListener('DOMContentLoaded', function () {
  new DigitalPromoManager();
});

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/assets/js/digital-promo-product.js"));
/******/ }
]);